var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { CFButton, CFText } from '../../components';
import { commonAttrs } from '../../utils';
import { CFDecorativeHeaderElements } from './DecorativeHeader.styles';
export const CFDecorativeHeader = (_a) => {
    var { alternateTheme, children, graphic, rightButton, title } = _a, rest = __rest(_a, ["alternateTheme", "children", "graphic", "rightButton", "title"]);
    const { DecorationsWrapper, Root } = CFDecorativeHeaderElements;
    return (React.createElement(Root, Object.assign({}, commonAttrs(rest)),
        (graphic || rightButton) && (React.createElement(DecorationsWrapper, { hasGraphic: !!graphic },
            graphic,
            rightButton && (React.createElement(CFButton, Object.assign({}, rightButton, { size: 'lg', variant: alternateTheme ? 'standalone-alternate' : 'standalone' }))))),
        title && (React.createElement(CFText.Title5, { color: alternateTheme ? 'text-and-element-alternate' : undefined }, title)),
        children));
};
